// @flow

export function addToCartJeanAndLen (customerId: string, subscriberId: string, productId: string): Promise<any> {
  return window.ccAddToCart(productId)
}
